// ============================================================
//  CONFIG CLIENT — seul fichier à modifier par déploiement
// ============================================================

const config = {

  // --- IDENTITÉ ---
  clientName:  "Hrtp",     // ex: "Bazin"
  clientShort: "HRT",    // ex: "BZN" (sidebar repliée)

  // --- COULEURS ---
  primaryColor: "#f06418",  // orange HRTP
  accentColor:  "#20242c",   // anthracite HRTP

  // --- API ---
  apiBase: "https://hrtp.ams-crm.fr/api",            // ex: "https://bazin.ams-crm.fr/api"

  // --- AUTH ---
  // Clés utilisées dans localStorage
  tokenKey: "hrtp_token",          // ex: "authToken"
  userKey:  "hrtp_user",           // ex: "adminUser"
  // Champ login renvoyé par l'API dans data.user
  loginField: "username",      // ex: "username" ou "login"

  // --- ROUTE PAR DÉFAUT APRÈS LOGIN ---
  defaultRoute: "/planning",  // ex: "/planning"

  // --- APPS ---
  // Ajoute / supprime selon le client
  apps: [
    { key: "alertes", label: "Centre d’alertes", icon: "🔔", native: true, component: "alerts", adminOnly: true },
    { key: "clients", label: "Clients", icon: "🏢", native: true, component: "clients", adminOnly: true },
    { key: "kanban",   label: "Kanban",      icon: "🧾", url: "https://kanban.hrtp.ams-crm.fr"   },
    { key: "planning", label: "Planning",    icon: "📅", url: "https://planning.hrtp.ams-crm.fr" },
    { key: "equipes", label: "Équipes", icon: "🦺", native: true, component: "teams", adminOnly: true },
    { key: "rh", label: "Ressources humaines", icon: "👥", native: true, module: "employees", adminOnly: true },
    { key: "vehicules", label: "Véhicules", icon: "🚐", native: true, module: "vehicles", adminOnly: true },
    { key: "commercial", label: "Commercial", icon: "📈", native: true, component: "commercial", adminOnly: true },
  ]

};

export default config;
